import { ParseQuery } from './parse-query';

import { CouponHistory } from './../data';

export class CouponHistoryQuery extends ParseQuery<CouponHistory> {
  constructor() {
    super(CouponHistory);
  }
}
